import {useEffect, useMemo} from 'react';
import { useQueryClient } from '@tanstack/react-query'
import { supabase } from '../supabaseClient'
import { useUser } from '../contextManager/user.context'
import { useConnections } from './useConnections'

export const useUnreadMessages = () => {
    const { userDetails } = useUser(); 
    const { connections } = useConnections();
    const queryClient = useQueryClient(); 
    const userId = userDetails?.id; 

    useEffect(() => {
        if (!userId) return;

        const refreshConnections = () => {
            console.log('Database changed (Messages or Connections).');
            queryClient.invalidateQueries({queryKey: ['connections', userId]})
        }

        const channel = supabase
            .channel(`global_badge_listener_${userId}`)
            .on(
                'postgres_changes',
                {event: '*', schema: 'public', table: 'messages'},
                refreshConnections
            )
            .on(
                'postgres_changes',
                {event: '*', schema: 'public', table: 'connections'},
                refreshConnections
            )
            .subscribe()

            return () => {
                supabase.removeChannel(channel)
            }
    }, [userId, queryClient])

    const unreadCount = useMemo(() => {
        if (!userId) return 0;

        return connections.reduce((acc, c) => {
            const isUnreadServer = c.hasUnreadMessages
            const isSavedUnread = c.status === 'saved'
            return acc + (isUnreadServer || isSavedUnread ? 1 : 0)
            }, 0)
        }, [connections, userId])

        const displayCount = unreadCount > 9 ? '9+' : unreadCount.toString()

        return {unreadCount, displayCount}
}

